<template>
  <div id="cust_forgotpassword">   
    <ForgotPasswordComponent></ForgotPasswordComponent>     
  </div>
</template>

<script>

  import ForgotPasswordComponent from '@/components/cust_components/forgot_password_component.vue';
  
  export default {
      name: 'password',
      data() {
          return {
          }
      },
      components: {     
        ForgotPasswordComponent,
      }
  }
</script>